/*
 * Copyright (c) Dito Technologies LLC
 */
import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import styles from "./SheetRendererNoteBox.module.scss";
import {
    SheetRendererNoteBox_box$data
} from "ui/feature/piece-play/common/sheet-renderer/__generated__/SheetRendererNoteBox_box.graphql";
import {NoteDisplayState} from "ui/feature/piece-play/common/PlayTypes";
import classnames from "classnames";

interface Props {
    box: SheetRendererNoteBox_box$data;
    pageHeight: number;
    pageWidth: number;
    state: NoteDisplayState;
}

const SheetRendererNoteBox: React.FC<Props> = ({state, box, pageWidth, pageHeight}) => {

    const width = React.useMemo(() => {
        return `${(box.width / pageWidth) * 100}%`;
    }, [box.width, pageWidth])

    const height = React.useMemo(() => {
        return `${(box.height / pageHeight) * 100}%`;
    }, [box.height, pageHeight]);

    const left = React.useMemo(() => {
        return `${(box.x / pageWidth) * 100}%`;
    }, [box.x, pageWidth]);

    const top = React.useMemo(() => {
        return `${(box.y / pageHeight) * 100}%`;
    }, [box.y, pageHeight]);

    const colorClass = React.useMemo(() => {
        switch (state) {
            case "none":
                return styles.noteDefault;
            case "error":
                return styles.noteError;
            case "current":
                return styles.noteCurrent;
            case "success":
                return styles.noteSuccess;
            default:
                return styles.noteDefault;
        }
    }, [state])

    return (
        <div className={classnames(styles.content, colorClass)} style={{
            width: width,
            height: height,
            left: left,
            top: top
        }} />
    )
}

export default createFragmentContainer(SheetRendererNoteBox, {
    box: graphql`
    fragment SheetRendererNoteBox_box on Box {
        x
        y
        width
        height
    }
    `
});